module.exports = __webpack_public_path__ + "fonts/SuisseIntl-BoldItalic.14235ed.woff";